"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doDelete = doDelete;
function doDelete(currentTurn, board, pieceRegistry, id, action, { combatStore }) {
    if (!board.containsPiece(id)) {
        return;
    }
    board.removePiece(id);
}
